/**
 * Shared HTTP status codes and API error text.
 * Axios copies `response.data.message` onto `err.message` in the interceptor;
 * read the envelope first so callers still work if that copy has not run.
 */

export const HTTP_BAD_REQUEST = 400;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_CONFLICT = 409;

/**
 * API envelope message, then the error's own message, then the caller's fallback.
 * Safe when `err` is missing.
 * @param {unknown} err
 * @param {string} genericMessage
 * @returns {string}
 */
export function getApiErrorMessage(err, genericMessage) {
  return err?.response?.data?.message || err?.message || genericMessage;
}
